import { Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/content';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-base" />
              </div>
              <span className="font-heading text-lg font-bold text-background-50">色影视</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              高清免费电影、电视剧、综艺大全，超清画质流畅播放，无需注册付费，每日更新最新热门影视剧集。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">首页</Link>
              </li>
              {Object.entries(categoryMap).map(([key, cat]) => (
                <li key={key}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">影视分类</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">科幻电影</Link></li>
              <li><Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">动作电影</Link></li>
              <li><Link to="/category/tv" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">古装电视剧</Link></li>
              <li><Link to="/category/tv" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">悬疑电视剧</Link></li>
              <li><Link to="/category/variety" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">热门综艺</Link></li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">联系我们</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">用户口碑</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 色影视 seyingshi.com - 高清免费电影电视剧在线观看平台
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>本站内容均来自网络，仅供学习交流</span>
          </div>
        </div>
      </div>
    </footer>
  );
}